export default __webpack_public_path__ + "static/media/hrm.22897f57.png";